export const farmerKeys = {
  farmerAnimals: () => ["farmerAnimals"],
  farmerSupervisor: () => ["farmerSupervisor"],
  maternalPhase: () => ["maternalPhase"],
  weaningPhase: () => ["weaningPhase"],
  yearlingPhase: () => ["yearlingPhase"],
};

export const adminKeys = {
  allAnimals: () => ["allAnimals"],
  allOfficials: () => ["allOfficials"],
  allFarms: () => ["allFarms"],
  allFarmers: () => ["allFarmers"],
  allSupervisors: () => ["allSupervisors"],
  assignSupervisor: () => ["assignSupervisor"],
  phenotype: () => ["phenotype"],
  statusChange: () => ["statusChange"],
  registerSupervisor: () => ["registerSupervisor"],
  updateAnimalDetail: () => ["updateAnimalDetail"],
};

export const supervisorKeys = {
  supervisorAnimals: () => ["supervisorAnimals"],
  assignDGR: () => ["assignDGR"],
  maternalPhase: () => ["maternalPhase"],
  weaningPhase: () => ["weaningPhase"],
  yearlingPhase: () => ["yearlingPhase"],
};

export const publicKeys = {
  getAnimal: () => ["getAnimal"],
};
